import API from '@aws-amplify/api';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { updateAISettingsForKnowledgePrompt, updateProject, updateProjectResource } from '@/graphql/mutations';
import {
    queryProjectGSI1,
    getProjectList,
    getProjectDetail,
    getExternalDeskProjectList,
    getExternalCustomerProjectList,
} from '@/graphql/queries';
import Logger from '@/common/utils/Logger';
import Storage from '@aws-amplify/storage';
import { getCorporationById, getCorporationListByIdList } from './organizationService';
import {
    prepareParamsGetListAllProjectOfUser,
    prepareParamsGetListUserProject,
    prepareParamsGetProjectInCorporationByTypeList,
    prepareParamsGetUserListInProject,
    prepareParamsQueryListProjectInCorporationForDelegate,
    prepareParamsGetUserInfoInProject,
    prepareParamsGetProjectBaseOfCorporation,
    prepareParamsGetAllProjectManagerOfProject,
    prepareParamsGetProjectCustomerOfCorporation,
    prepareParamsGetListProjectByUserId,
    prepareGetListProjectOfUserInCorporation,
    prepareParamsGetProjectDeskOnOfCorporation
} from './dynamoDBRequestDto/DynamoDBProjectRequestDto';
import * as DynamoDBProjectRequestDto from './dynamoDBRequestDto/DynamoDBProjectRequestDto';
import { cloneDeep } from 'lodash';
import { getPublicAPI } from './publicService';
import { I18n } from 'aws-amplify';
import { getUserListByIdList } from './userService';


export const getProjectListInCorporation = async (APIClient, corporationId) => {
    try {
        let typeList = [
            Constant.PROJECT_TYPE.BASE,
            Constant.PROJECT_TYPE.CUSTOMER,
            Constant.PROJECT_TYPE.GENERAL
        ];

        let dynamodbParams = prepareParamsGetProjectInCorporationByTypeList(
            corporationId,
            typeList,
            Constant.ACTIVE_FLAG.ACTIVE
        );

        if (!dynamodbParams || Utils.isEmptyObject(dynamodbParams)) {
            return [];
        }

        let resProjectList = await API.graphql({
            query: getProjectList,
            variables: {
                params: {
                    expression: JSON.stringify(dynamodbParams)
                }
            }
        });

        return !Utils.isEmptyArray(resProjectList.data.getProjectList)
            ? resProjectList.data.getProjectList
            : [];
    } catch (err) {
        console.log('getProjectListInCorporation error: ', err);
        return [];
    }
};

export const getProjectListInCorporationByType = async (APIClient, corporationId, typeList) => {
    try {
        let dynamodbParams = prepareParamsGetProjectInCorporationByTypeList(
            corporationId,
            typeList,
            Constant.ACTIVE_FLAG.ACTIVE
        );

        if (!dynamodbParams || Utils.isEmptyObject(dynamodbParams)) {
            return [];
        }

        let resProjectList = await API.graphql({
            query: getProjectList,
            variables: {
                params: {
                    expression: JSON.stringify(dynamodbParams)
                }
            }
        });

        return !Utils.isEmptyArray(resProjectList.data.getProjectList)
            ? resProjectList.data.getProjectList
            : [];
    } catch (err) {
        console.log('getProjectListInCorporation error: ', err);
        return [];
    }
};

export const getAllProjectListInCorporation = async (APIClient, corporationId, active) => {
    try {
        let typeList = [
            Constant.PROJECT_TYPE.BASE,
            Constant.PROJECT_TYPE.CUSTOMER,
            Constant.PROJECT_TYPE.GENERAL
        ];

        let dynamodbParams = prepareParamsGetProjectInCorporationByTypeList(
            corporationId,
            typeList,
            active
        );

        if (!dynamodbParams || Utils.isEmptyObject(dynamodbParams)) {
            return [];
        }

        let resProjectList = await API.graphql({
            query: getProjectList,
            variables: {
                params: {
                    expression: JSON.stringify(dynamodbParams)
                }
            }
        });

        return !Utils.isEmptyArray(resProjectList.data.getProjectList)
            ? resProjectList.data.getProjectList
            : [];
    } catch (err) {
        console.log('getAllProjectListInCorporation error: ', err);
        return [];
    }
};

/**
 * Get project list in corporation by userId
 * @param {*} APIClient
 * @param {*} corporationId
 * @param {*} userId
 * @returns projectList
 */
export const getProjectListInCorporationByUserId = async (APIClient, corporationId, userId) => {
    try {
        const expression = prepareParamsGetListProjectByUserId(corporationId, userId);
        if (!expression || Utils.isEmptyObject(expression)) {
            return [];
        }

        let resUserProjectList = await API.graphql({
            query: getProjectList,
            variables: {
                params: {
                    expression: JSON.stringify(expression)
                }
            }
        });
        if (
            Utils.isEmptyObject(resUserProjectList) ||
            Utils.isEmptyArray(resUserProjectList.data.getProjectList)
        ) {
            console.log('getProjectListInCorporationByUserId error: userList empty');
            return [];
        }

        // get detail project
        let userProjectList = resUserProjectList.data.getProjectList;
        let lisProjectId = [];
        userProjectList.forEach(user => {
            lisProjectId.push(user.projectId);
        });
        const expressionGetListProjectDetail = prepareGetListProjectOfUserInCorporation(
            corporationId,
            lisProjectId
        );
        if (
            !expressionGetListProjectDetail ||
            Utils.isEmptyObject(expressionGetListProjectDetail)
        ) {
            return [];
        }
        let resGetListProjectDetail = await API.graphql({
            query: getProjectList,
            variables: {
                params: {
                    expression: JSON.stringify(expressionGetListProjectDetail)
                }
            }
        });
        let projectList =
            !Utils.isEmptyObject(resGetListProjectDetail.data.getProjectList) &&
            !Utils.isEmptyArray(resGetListProjectDetail.data.getProjectList)
                ? resGetListProjectDetail.data.getProjectList
                : [];
        return projectList;
    } catch (err) {
        console.log('getProjectListInCorporationByUserId error: ', err);
        return [];
    }
};

/**
 * Get user list in project. User member, user manager
 * @param {*} APIClient
 * @param {*} projectId
 * @returns guestUserList
 */
export const getUserListInProject = (APIClient, projectId) =>
    new Promise(async (resolve, reject) => {
        try {
            // get project user list
            let dynamodbParams = prepareParamsGetUserListInProject(projectId);
            if (!dynamodbParams || Utils.isEmptyObject(dynamodbParams)) {
                return [];
            }

            let resUserList = await API.graphql({
                query: getProjectList,
                variables: {
                    params: {
                        expression: JSON.stringify(dynamodbParams)
                    }
                }
            });

            // get user detail
            let projectUserList = !Utils.isEmptyArray(resUserList.data.getProjectList)
                ? resUserList.data.getProjectList
                : [];

            let userIdList = [];
            for (const userProject of projectUserList) {
                if (userProject?.id2) {
                    userIdList.push(userProject.id2);
                }
            };
    
            let allUserDetailList = await getUserListByIdList(APIClient, userIdList);

            let guestUserListInProject = [];
            await Promise.all(
                projectUserList.map(async projectUser => {
                    // get user detail by userId
                    let userDetail = allUserDetailList.find(user => user.id === projectUser.id2);
                    
                    // Skip if userDetail not found
                    if (!userDetail) {
                        console.warn('⚠️ User not found for id:', projectUser.id2);
                        return;
                    }
                    
                    // if userType is guest then push to list and get avatar
                    // if (Constant.USER_TYPER.CUSTOMER === userDetail.userType) {
                    let avatar = Constant.AVATAR_DEFAULT;
                    // call s3
                    if (!Utils.isEmptyString(userDetail?.image)) {
                        avatar = await Storage.get(userDetail?.image);
                    }
                    userDetail.avatar = avatar;
                    userDetail.affiliationProject = projectUser.projectId;

                    if (userDetail.active !== Constant.ACTIVE_FLAG.DELETED) {
                        guestUserListInProject.push(userDetail);
                    }
                })
            );
            resolve(guestUserListInProject);
        } catch (err) {
            console.log('getUserListInProject error:', err);
            reject(err);
        }
    });

/**
 * Update project by ID
 *
 * @param {*} APIClient
 * @param {*} projectId
 * @param {*} projectDetail
 * @return projectData
 */
export const updateProjectDetail = async (APIClient, projectId, projectDetail) => {
    try {
        let input = {
            id: projectId,
            ...projectDetail
        };
        let res = await API.graphql({ query: updateProject, variables: { input: input } });
        return res.data?.updateProject;
    } catch (err) {
        console.log(err);
        return null;
    }
};

/**
 * getProjectDeskOn
 * get project desk on (desk on + public on / desk on + public off)
 * @param {*} APIClient
 * @param {*} corporationId
 * @returns
 */
export const getProjectDeskOn = async (APIClient, corporationId) => {
    try {
        let dynamodbParams = prepareParamsGetProjectDeskOnOfCorporation(
            corporationId,
            Constant.ACTIVE_FLAG.ACTIVE
        );
        if (!dynamodbParams || Utils.isEmptyObject(dynamodbParams)) {
            return [];
        }

        const resProject = await API.graphql({
            query: getProjectList,
            variables: {
                params: {
                    expression: JSON.stringify(dynamodbParams)
                }
            }
        });
        return !Utils.isEmptyArray(resProject.data.getProjectList)
            ? resProject.data.getProjectList
            : [];
    } catch (err) {
        console.log('getProjectDeskOn :>> ', err);
        return [];
    }
};

export const getProjectDeskOnPublicOn = async (APIClient, corporationId) => {
    try {
        let dynamodbParams = DynamoDBProjectRequestDto.prepareParamsGetProjectDeskOnPublicOnInCorporation(
            corporationId
        );
        if (!dynamodbParams || Utils.isEmptyObject(dynamodbParams)) {
            return [];
        }

        const resProject = await API.graphql({
            query: getProjectList,
            variables: {
                params: {
                    expression: JSON.stringify(dynamodbParams)
                }
            }
        });
        return !Utils.isEmptyArray(resProject.data.getProjectList)
            ? resProject.data.getProjectList
            : [];
    } catch (err) {
        console.log('getProjectDeskOn :>> ', err);
        return [];
    }
};

/**
 * filterExternalDeskProject
 * @param {*} APIClient
 * @param {*} projectId
 * @param {*} keyword
 * @returns
 */
export const filterExternalDeskProject = async (APIClient, projectId, corporationId, keyword) => {
    try {
        let searchCondition = {
            params: {
                projectId,
                corporationId,
                keyword
            }
        };

        const res = await API.graphql({
            query: getExternalDeskProjectList,
            variables: searchCondition
            // authMode: Constant.AUTH_MODE_API_KEY,
        });

        let projectList = !Utils.isEmptyArray(res?.data?.getExternalDeskProjectList)
            ? res?.data?.getExternalDeskProjectList
            : [];
        return projectList;
    } catch (err) {
        console.log('filterExternalDeskProject :>> ', err);
        return [];
    }
};

const getActiveQACustomerProjectDetail = async (APIClient, project) => {
    if (!project) {
        return [];
    }

    try {
        const getB2BCustomerProjectListParams = DynamoDBProjectRequestDto.prepareParamsGetB2BCustomerProjectList(
            project.projectId,
            Constant.ACTIVE_FLAG.ACTIVE
        );
        let resGetB2BCustomerProjectListParams = await API.graphql({
            query: getProjectList,
            variables: {
                params: {
                    expression: JSON.stringify(getB2BCustomerProjectListParams)
                }
            }
        });

        if (Utils.isEmptyArray(resGetB2BCustomerProjectListParams.data?.getProjectList)) {
            return [];
        }

        const getB2BCustomerProjectListRes =
            resGetB2BCustomerProjectListParams.data?.getProjectList;

        let b2bCustomerList = [];
        await Promise.all(
            getB2BCustomerProjectListRes.map(async prj => {
                const prjDetail = await getProjectById(API, prj.id2);
                if (!Utils.isEmptyObject(prjDetail) && prjDetail.active === Constant.ACTIVE_FLAG.ACTIVE) {
                    const corpDetail = await getCorporationById(API, prjDetail.affiliationOrganization);
                    if (
                        Utils.isEmptyObject(corpDetail) ||
                        corpDetail.active !== Constant.ACTIVE_FLAG.ACTIVE ||
                        corpDetail.knowledgeService !== Constant.STATUS_SERVICE_PERMISSION.ON ||
                        corpDetail.contractType === Constant.CORPORATION_CONTRACT_TYPE.GUEST
                    ) return;
                    
                    b2bCustomerList.push({
                        id: prjDetail.id,
                        name: prjDetail.name,
                        type: prjDetail.type,
                        corpDetail: {
                            id: corpDetail.id,
                            name: corpDetail.name,
                            domain: corpDetail.organizationDomain,
                            limitValue: corpDetail.limitValue,
                            contractType: corpDetail.contractType,
                            inviter: corpDetail?.inviter,
                            inviterSetting: corpDetail?.inviterSetting,
                            inviterUsingChatAI: corpDetail?.inviterUsingChatAI
                        },
                        projectSetting: prjDetail.projectSetting ? prjDetail.projectSetting : '',
                        affiliationOrganization: prj.affiliationOrganization
                    })
                }
            })
        );

        return b2bCustomerList;
    } catch (err) {
        console.log('QACustomerProjectDetail error: ', err);
        return [];
    }
}

const getActiveHelpdeskCustomerProjectDetail = async (APIClient, projectInuseDetail, corporationInuseDetail) => {
    try {
        if (Utils.isEmptyObject(projectInuseDetail)) return [];

        let listProjectDesk = await getActiveB2BHelpdeskProjectListOfProject(API, projectInuseDetail.projectId);
        if (Utils.isEmptyArray(listProjectDesk)) return [];

        let listHelpdeskCustomerProject = [];
        await Promise.all(
            listProjectDesk.map(async (projectId, index) => {
                // get project data
                let projectData = await getProjectById(API, projectId);
                if (Utils.isEmptyObject(projectData) || projectData.active !== Constant.ACTIVE_FLAG.ACTIVE)
                return;
                // Helpdesk prj only
                if (projectData.affiliationOrganization) {
                    const corporationData = await getCorporationById( API, projectData.affiliationOrganization);
                    if (
                        Utils.isEmptyObject(corporationData) ||
                        corporationData.active !== Constant.ACTIVE_FLAG.ACTIVE ||
                        (corporationData.contractType === Constant.CORPORATION_CONTRACT_TYPE.PREMIUM && corporationData.knowledgeService !== Constant.STATUS_SERVICE_PERMISSION.ON) ||
                        (corporationData.contractType === Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK && corporationInuseDetail.knowledgeService !== Constant.STATUS_SERVICE_PERMISSION.ON)
                    ) return;
                    listHelpdeskCustomerProject.push({
                        id: projectData.id,
                        name: projectData.name,
                        type: projectData.type,
                        corpDetail: {
                            id: corporationData.id,
                            name: corporationData.name,
                            domain: corporationData.organizationDomain,
                            limitValue: corporationData.limitValue,
                            contractType: corporationData.contractType,
                            inviter: corporationData?.inviter,
                            inviterSetting: corporationData?.inviterSetting,
                            inviterUsingChatAI: corporationData?.inviterUsingChatAI
                        },
                        projectSetting: projectData.projectSetting ? projectData.projectSetting : '',
                        affiliationOrganization: projectData.affiliationOrganization
                    })
                }
            })
        );
        
        return listHelpdeskCustomerProject;
    } catch (err) {
        console.log('HelpdeskCustomerProjectDetail error: ', err);
        return [];
    }
}

const getLabelOption = (project, corporation) => {

    let projectName = JSON.parse(project.name);
    projectName = projectName ? projectName['jp']?.text : '';
    let orgName = JSON.parse(corporation.name);
    orgName = orgName ? orgName['jp']?.text : '';
    
    return `${projectName} (${orgName})`
}

const customProjectList = (prjList, project, filter = false, customLabel = false, isExternal = false) => {
    if (Utils.isEmptyArray(prjList)) return [];
    let clonedProjectList = [...prjList]

    if (filter) {
        clonedProjectList = clonedProjectList.filter(
            prj =>
                prj?.id !== project.id &&
                prj?.corporationData?.active !== Constant.CORPORATION_ACTIVE.DELETED &&
                prj?.corporationData?.knowledgeService !== Constant.STATUS_SERVICE_PERMISSION.OFF
        );
    }

    clonedProjectList = clonedProjectList.filter(projectData => projectData);
    
    clonedProjectList = clonedProjectList.map(prj => ({
        id: prj.id,
        name: prj.name,
        value: prj.id,
        label: customLabel? getLabelOption(prj, prj.corpDetail) : Utils.getProjectName(prj),
        type: isExternal ? Constant.PROJECT_TYPE.PRJ_BUSINESS_CUSTOMER : prj.type,
        corpId: prj.corpDetail?.id ? prj.corpDetail?.id : prj.affiliationOrganization,
        affiliationOrganization: prj.corpDetail?.id ? prj.corpDetail?.id : prj.affiliationOrganization,
        projectSetting: prj.projectSetting,
        organizationDomain: prj.corpDetail.domain,
        organizationName: prj.corpDetail.name,
        limitValue: prj.corpDetail.limitValue,
        contractType: prj.corpDetail.contractType,
        inviter: prj.corpDetail?.inviter,
        inviterSetting: prj.corpDetail?.inviterSetting,
        inviterUsingChatAI: prj?.corpDetail?.inviterUsingChatAI
    }));
    return Utils.sortListByLabelDictionaryASC(clonedProjectList);
};

export const getInitOrganizationDataInKnowledgePanel = async (
    userPermission,
    corporation,
    project,
    setVisibilityKnowledgeAtom,
    setIsShowVisibilityKnowledgeAtom,
    setProjectSelectedId,
    setViewKnowledgeProjectSelected,
    setCorporationSelectedId,
    projectSelectedId,
    isCustomer
) => {
    if (Utils.isEmptyObject(userPermission) || Utils.isEmptyObject(corporation) || Utils.isEmptyObject(project)) return {};

    let initOrgData = {
        value: '',
        label: '',
        corpId: '',
        prjId: '',
        internalProjectList: [],
        externalProjectList: [],
        limitValue: {}
    }
    let internalProjectList = [];
    let initOrgDataValue = '';
    let initOrgDataLabel = '';
    let initOrgId = corporation?.id;
    let isNotEmptyArrayExternalProjectList = false;
    initOrgData.corpId = corporation.id;
    initOrgData.prjId = project.id;
    const userPermissionType = userPermission.type;

    switch (userPermissionType) {
        case Constant.USER_PERMISSION_VIEW_KNOWLEDGE.MEMBER_OF_PROJECT: {
            let [
                internalProjects,
                externalQAProjects,
                externalHelpdeskProjects
            ] = await Promise.all([
                getProjectListInCorporationByType(API, corporation?.id, [
                    Constant.PROJECT_TYPE.GENERAL
                ]),
                getActiveQACustomerProjectDetail(API, project),
                getActiveHelpdeskCustomerProjectDetail(API, project, corporation)
            ]);
            // re mapping data of internalProjects
            internalProjects = internalProjects.map(prj => {
                return {
                    id: prj.id,
                    name: prj.name,
                    type: prj.type,
                    corpDetail: {
                        id: corporation.id,
                        name: corporation.name,
                        domain: corporation.organizationDomain,
                        limitValue: corporation.limitValue,
                        contractType: corporation.contractType,
                        inviter: corporation?.inviter,
                        inviterSetting: corporation?.inviterSetting,
                        inviterUsingChatAI: corporation?.inviterUsingChatAI
                    },
                    projectSetting: prj.projectSetting,
                    affiliationOrganization: prj.affiliationOrganization
                };
            });

            initOrgData.internalProjectList = !Utils.isEmptyArray(internalProjects)
                ? customProjectList(internalProjects, project, true)
                : [];

            let externalProjects = [...externalQAProjects, ...externalHelpdeskProjects];
            let uniqueProjectList = new Set();
            externalProjects = externalProjects.filter(
                prj => !uniqueProjectList.has(prj.id) && uniqueProjectList.add(prj.id)
            );
            if (!Utils.isEmptyArray(externalProjects)) {
                externalProjects = externalProjects
                    .filter(prj => !Utils.isEmptyObject(prj) && prj.id !== project.id)
                    .map(prj => {
                        return {
                            id: prj.id,
                            name: Utils.getProjectName(prj),
                            value: prj.id,
                            label: getLabelOption(prj, prj.corpDetail),
                            type: Constant.PROJECT_TYPE.PRJ_BUSINESS_CUSTOMER,
                            corpId: prj.corpDetail.id,
                            affiliationOrganization: prj.corpDetail?.id,
                            projectSetting: prj.projectSetting,
                            organizationDomain: prj.corpDetail.domain,
                            organizationName: prj.corpDetail.name,
                            limitValue: prj?.corpDetail?.limitValue,
                            contractType: prj?.corpDetail?.contractType,
                            inviter: prj?.corpDetail?.inviter,
                            inviterSetting: prj?.corpDetail?.inviterSetting,
                            inviterUsingChatAI: prj?.corpDetail?.inviterUsingChatAI
                        };
                    });
            }
            initOrgData.externalProjectList = !Utils.isEmptyArray(externalProjects)
                ? Utils.sortListByLabelDictionaryASC(externalProjects)
                : [];
            isNotEmptyArrayExternalProjectList = !Utils.isEmptyArray(
                initOrgData.externalProjectList
            );
            // form detailTicket
            if (isCustomer) {
                const findPrj = [
                    ...initOrgData.internalProjectList,
                    ...initOrgData.externalProjectList
                ].find(prj => prj.id === projectSelectedId);
                if (!Utils.isEmptyObject(findPrj)) {
                    initOrgDataValue = findPrj.id;
                    initOrgDataLabel = findPrj.label;
                    setProjectSelectedId(findPrj.id);
                    setViewKnowledgeProjectSelected({
                        projectId: findPrj.id,
                        corporationId: findPrj.corpId,
                        inviter: findPrj?.inviter
                    });
                    setCorporationSelectedId(findPrj.affiliationOrganization);
                } else {
                    initOrgDataValue = Constant.KNOWLEDGE_VIEW_OPTION.PRJ_IN_USE;
                    initOrgDataLabel = I18n.get('CM-LABEL-PRJ-IN-USE');
                    setProjectSelectedId(project.id);
                    setViewKnowledgeProjectSelected({
                        projectId: isNotEmptyArrayExternalProjectList
                            ? initOrgData.externalProjectList[0].id
                            : '',
                        corporationId: isNotEmptyArrayExternalProjectList
                            ? initOrgData.externalProjectList[0].corpId
                            : '',
                        inviter: isNotEmptyArrayExternalProjectList
                            ? initOrgData.externalProjectList[0]?.inviter
                            : ''
                    });
                    setCorporationSelectedId(corporation.id);
                }
                // from sidebar
            } else {
                initOrgDataValue = Constant.KNOWLEDGE_VIEW_OPTION.PRJ_IN_USE;
                initOrgDataLabel = I18n.get('CM-LABEL-PRJ-IN-USE');
                setProjectSelectedId(project.id);
                setViewKnowledgeProjectSelected({
                    projectId: project.id,
                    corporationId: corporation.id,
                    inviter: corporation?.inviter
                });
                setCorporationSelectedId(corporation.id);
            }

            initOrgData.value = initOrgDataValue;
            initOrgData.label = initOrgDataLabel;

            setVisibilityKnowledgeAtom(
                isCustomer
                    ? Constant.VISIBILITY_SETTING_TYPE.CUSTOMER
                    : Constant.VISIBILITY_SETTING_TYPE.PROJECT
            );
            setIsShowVisibilityKnowledgeAtom(isCustomer ? false : true);

            return initOrgData;
        }
        case Constant.USER_PERMISSION_VIEW_KNOWLEDGE.PERSONAL_PROJECT:
            internalProjectList = await getProjectListInCorporationByType(API, corporation?.id, [
                Constant.PROJECT_TYPE.GENERAL
            ]);
            // re mapping data of internalProjects.
            internalProjectList = internalProjectList.map(prj => {
                return {
                    id: prj.id,
                    name: prj.name,
                    type: prj.type,
                    corpDetail: {
                        id: corporation.id,
                        name: corporation.name,
                        domain: corporation.organizationDomain,
                        limitValue: corporation.limitValue,
                        contractType: corporation.contractType,
                        inviter: corporation?.inviter,
                        inviterSetting: corporation?.inviterSetting,
                        inviterUsingChatAI: corporation?.inviterUsingChatAI
                    },
                    projectSetting: prj.projectSetting,
                    affiliationOrganization: prj.affiliationOrganization
                };
            });
            initOrgData.internalProjectList = !Utils.isEmptyArray(internalProjectList)
                ? customProjectList(internalProjectList, project)
                : [];
            // from detailTicket
            if (isCustomer) {
                const findPrj = [...initOrgData.internalProjectList].find(
                    prj => prj.id === projectSelectedId
                );
                if (!Utils.isEmptyObject(findPrj)) {
                    initOrgDataValue = findPrj.id;
                    initOrgDataLabel = Utils.getProjectName(findPrj);

                    setProjectSelectedId(findPrj.id);
                    setViewKnowledgeProjectSelected({
                        projectId: findPrj.id,
                        corporationId: findPrj.corpId,
                        inviter: findPrj?.inviter
                    });
                } else {
                    initOrgDataValue = Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG;
                    initOrgDataLabel = I18n.get('CM-LABEL-ALL-KNOWLEDGE-IN-ORG');
                    setProjectSelectedId(Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG);
                }
                // from sidebar
            } else {
                initOrgDataValue = Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG;
                initOrgDataLabel = I18n.get('CM-LABEL-ALL-KNOWLEDGE-IN-ORG');
                setProjectSelectedId(Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG);
            }

            initOrgData.value = initOrgDataValue;
            initOrgData.label = initOrgDataLabel;

            setCorporationSelectedId(corporation.id);
            setVisibilityKnowledgeAtom(Constant.VISIBILITY_SETTING_TYPE.IN_ORG);
            setIsShowVisibilityKnowledgeAtom(false);

            return initOrgData;

        case Constant.USER_PERMISSION_VIEW_KNOWLEDGE.B2C:
            internalProjectList = await getActiveProjectDetailListIsB2CByUserId(
                API,
                userPermission?.userId
            );
            if (!Utils.isEmptyArray(internalProjectList)) {
                internalProjectList = internalProjectList.map(prj => ({
                    ...prj,
                    corpDetail: {
                        ...prj.corpDetail,
                        name: corporation?.name,
                        domain: corporation?.organizationDomain,
                        limitValue: corporation?.limitValue,
                        contractType: corporation?.contractType,
                        inviter: corporation?.inviter,
                        inviterSetting: corporation?.inviterSetting,
                        inviterUsingChatAI: corporation?.inviterUsingChatAI
                    }
                }));
                initOrgData.internalProjectList = customProjectList(internalProjectList, project);

                //from detailTicket
                if (isCustomer) {
                    const findPrj = [...initOrgData.internalProjectList].find(
                        prj => prj.id === projectSelectedId
                    );
                    if (!Utils.isEmptyObject(findPrj)) {
                        initOrgDataValue = findPrj.id;
                        initOrgDataLabel = Utils.getProjectName(findPrj);

                        setProjectSelectedId(findPrj.id);
                        setViewKnowledgeProjectSelected({
                            projectId: findPrj.id,
                            corporationId: findPrj.corpId,
                            inviter: findPrj?.inviter
                        });
                    } else {
                        initOrgDataValue = internalProjectList[0].id;
                        initOrgDataLabel = Utils.getProjectName(internalProjectList[0]);

                        setProjectSelectedId(internalProjectList[0].id);
                        setViewKnowledgeProjectSelected({
                            projectId: internalProjectList[0].id,
                            corporationId: internalProjectList[0].corpId,
                            inviter: internalProjectList[0]?.inviter
                        });
                    }
                    // from sidebar
                } else {
                    initOrgDataValue = internalProjectList[0].id;
                    initOrgDataLabel = Utils.getProjectName(internalProjectList[0]);

                    setProjectSelectedId(internalProjectList[0].id);
                    setViewKnowledgeProjectSelected({
                        projectId: internalProjectList[0].id,
                        corporationId: internalProjectList[0].corpDetail.id,
                        inviter: internalProjectList[0].corpDetail.inviter
                    });
                }

                initOrgData.value = initOrgDataValue;
                initOrgData.label = initOrgDataLabel;

                setCorporationSelectedId(internalProjectList[0].corpDetail.id);
            }
            setVisibilityKnowledgeAtom(Constant.VISIBILITY_SETTING_TYPE.CUSTOMER);
            setIsShowVisibilityKnowledgeAtom(false);

            return initOrgData;

        case Constant.USER_PERMISSION_VIEW_KNOWLEDGE.GUEST_PARTNER:
            const externalProjectList = await getActiveQACustomerProjectDetail(API, project);
            initOrgData.externalProjectList = !Utils.isEmptyArray(externalProjectList)
                ? customProjectList(externalProjectList, project, false, true, true)
                : [];

            // from detailTicket
            if (isCustomer) {
                const findPrj = [...initOrgData.externalProjectList].find(
                    prj => prj.id === projectSelectedId
                );
                if (!Utils.isEmptyObject(findPrj)) {
                    initOrgDataValue = findPrj.id;
                    initOrgDataLabel = Utils.getProjectName(findPrj);

                    setProjectSelectedId(findPrj.id);
                    setViewKnowledgeProjectSelected({
                        projectId: findPrj.id,
                        corporationId: findPrj.corpId,
                        inviter: findPrj?.inviter
                    });
                    setCorporationSelectedId(findPrj.corpId);
                } else {
                    initOrgDataValue = Constant.KNOWLEDGE_VIEW_OPTION.PRJ_IN_USE;
                    initOrgDataLabel = I18n.get('CM-LABEL-PRJ-IN-USE');

                    setProjectSelectedId(project.id);
                    setCorporationSelectedId(corporation.id);
                }
                // from sidebar
            } else {
                initOrgDataValue = Constant.KNOWLEDGE_VIEW_OPTION.PRJ_IN_USE;
                initOrgDataLabel = I18n.get('CM-LABEL-PRJ-IN-USE');

                setProjectSelectedId(project.id);
                setCorporationSelectedId(corporation.id);
            }

            initOrgData.value = initOrgDataValue;
            initOrgData.label = initOrgDataLabel;

            setVisibilityKnowledgeAtom(Constant.VISIBILITY_SETTING_TYPE.PROJECT);
            setIsShowVisibilityKnowledgeAtom(isCustomer ? false : true);

            return initOrgData;

        case Constant.USER_PERMISSION_VIEW_KNOWLEDGE.GUEST_SUPPORTED:
            const externalListPrj = await getActiveHelpdeskCustomerProjectDetail(
                API,
                project,
                corporation
            );
            if (!Utils.isEmptyArray(externalListPrj)) {
                initOrgData.externalProjectList = customProjectList(
                    externalListPrj,
                    project,
                    false,
                    true,
                    true
                );

                // from detailTicket
                if (isCustomer) {
                    const findPrj = [...initOrgData.externalProjectList].find(
                        prj => prj.id === projectSelectedId
                    );
                    if (!Utils.isEmptyObject(findPrj)) {
                        initOrgDataValue = findPrj.id;
                        initOrgDataLabel = findPrj.label;
                        initOrgId = findPrj.corpId;

                        setProjectSelectedId(findPrj.id);
                        setViewKnowledgeProjectSelected({
                            projectId: findPrj.id,
                            corporationId: findPrj.corpId,
                            inviter: findPrj?.inviter
                        });

                        setCorporationSelectedId(findPrj.affiliationOrganization);
                    } else {
                        initOrgDataValue = initOrgData.externalProjectList[0].id;
                        initOrgDataLabel = initOrgData.externalProjectList[0].label;

                        setProjectSelectedId(initOrgData.externalProjectList[0].id);
                        setViewKnowledgeProjectSelected({
                            projectId: initOrgData.externalProjectList[0].id,
                            corporationId: initOrgData.externalProjectList[0].corpId,
                            inviter: initOrgData.externalProjectList[0]?.inviter
                        });

                        setCorporationSelectedId(externalListPrj[0].corpDetail.id);
                    }
                    // from sidebar
                } else {
                    initOrgDataValue = initOrgData.externalProjectList[0].id;
                    initOrgDataLabel = initOrgData.externalProjectList[0].label;
                    initOrgId = initOrgData.externalProjectList[0].corpId;

                    setProjectSelectedId(initOrgData.externalProjectList[0].id);
                    setViewKnowledgeProjectSelected({
                        projectId: initOrgData.externalProjectList[0].id,
                        corporationId: initOrgData.externalProjectList[0].corpId,
                        inviter: initOrgData.externalProjectList[0]?.inviter
                    });

                    setCorporationSelectedId(externalListPrj[0].corpDetail.id);
                }

                initOrgData.value = initOrgDataValue;
                initOrgData.label = initOrgDataLabel;
                initOrgData.corpId = initOrgId;
            }

            setVisibilityKnowledgeAtom(Constant.VISIBILITY_SETTING_TYPE.CUSTOMER);
            setIsShowVisibilityKnowledgeAtom(false);

            return initOrgData;

        default:
            return {};
    }
}

/**
 * getListProjectExternalDesk
 * @param {*} APIClient
 * @param {*} projectDetail
 * @returns listDesk
 */
export const getListProjectExternalDesk = async (APIClient, projectDetail, activeCorporation = false) => {
    try {
        if (Utils.isEmptyObject(projectDetail)) {
            return [];
        }

        let listProjectDeskId = await getActiveB2BHelpdeskProjectListOfProject(API, projectDetail.id);
        if (Utils.isEmptyArray(listProjectDeskId)) {
            return [];
        }

        let listDesk = [];
        let listProjectDeskDetail = await getProjectListByIdList(listProjectDeskId);
        listProjectDeskDetail = listProjectDeskDetail.filter(
            projectData =>
                !Utils.isEmptyObject(projectData) &&
                projectData.active === Constant.ACTIVE_FLAG.ACTIVE &&
                !Utils.isProjectGuest(projectData)
        );

        if (Utils.isEmptyArray(listProjectDeskDetail)) {
            return [];
        }

        let corpIdList = [];
        listProjectDeskDetail.forEach(projectDesk => {
            if (projectDesk?.affiliationOrganization) {
                corpIdList.push(projectDesk?.affiliationOrganization);
            }
        });

        corpIdList = [...new Set(corpIdList)];
        let corpDetailList = await getCorporationListByIdList(corpIdList);

        for (const projectData of listProjectDeskDetail) {
            let corporationData = corpDetailList.find(corp => corp.id === projectData.affiliationOrganization);
            if (Utils.isEmptyObject(corporationData)) continue;
            if (activeCorporation && corporationData.active !== Constant.ACTIVE_FLAG.ACTIVE) continue;

            projectData.corporationData = corporationData;
            listDesk.push(projectData);
        }

        return listDesk;
    } catch (err) {
        console.log('getListProjectExternalDesk :>> ', err);
        return [];
    }
};


/**
 * getProjectListByIdList
 * @param {*} projectList 
 * @returns 
 */
export const getProjectListByIdList = async (projectIdList) => {
    if (!projectIdList || Utils.isEmptyArray(projectIdList)) {
        return [];
    }
    projectIdList = [...new Set(projectIdList)];

    try {
        const queryToProjectTableWithBatchIdDto = {
            query: getProjectList,
            variables: {
                params: {
                    ids: projectIdList,
                    method: Constant.QUERY_METHOD.BATCH
                }
            }
        };

        let resProjectList = await API.graphql(queryToProjectTableWithBatchIdDto);
        if (!Utils.isEmptyArray(resProjectList?.data?.getProjectList)) {
            return resProjectList?.data?.getProjectList;
        }
        return [];
    } catch (err) {
        Logger.error('getProjectBaseByCorporationId error: ', err);
        return [];
    }
};

/**
 * Get project base by corporationId
 * @param {*} APIClient
 * @param {*} corporationId
 * @returns projectBase of corporation
 */
export const getProjectBaseByCorporationId = async (APIClient, corporationId) => {
    if (!corporationId) {
        return {};
    }

    try {
        let getProjectBaseParams = prepareParamsGetProjectBaseOfCorporation(corporationId);
        let resGetProjectBaseParams = await API.graphql({
            query: getProjectList,
            variables: {
                params: {
                    expression: JSON.stringify(getProjectBaseParams)
                }
            }
        });

        if (Utils.isEmptyArray(resGetProjectBaseParams?.data?.getProjectList)) {
            return {};
        }

        let projectBase = resGetProjectBaseParams?.data?.getProjectList[0];
        return projectBase;
    } catch (err) {
        Logger.error('getProjectBaseByCorporationId error: ', err);
        return {};
    }
};

/**
 * Get guest project list by corporation
 * @param {*} APIClient
 * @param {*} corporationId
 * @returns guestProjectList
 */
export const getCustomerProjectByCorporation = async (APIClient, corporationId) => {
    if (!corporationId) {
        return {};
    }

    try {
        let getProjectCustomerParams = prepareParamsGetProjectCustomerOfCorporation(corporationId);
        let resGetProjectCustomerParams = await API.graphql({
            query: getProjectList,
            variables: {
                params: {
                    expression: JSON.stringify(getProjectCustomerParams)
                }
            }
        });

        if (Utils.isEmptyArray(resGetProjectCustomerParams?.data?.getProjectList)) {
            return {};
        }

        let projectCustomer = resGetProjectCustomerParams?.data?.getProjectList[0];
        return projectCustomer;
    } catch (err) {
        Logger.error('getProjectCustomerByCorporationId error: ', err);
        return {};
    }
};

export const getProjectById = async (APIClient, projectId) => {
    try {
        let res = await API.graphql({
            query: getProjectDetail,
            variables: {
                params: {
                    id: projectId
                }
            }
        });
        return !Utils.isEmptyObject(res.data.getProjectDetail) ? res.data.getProjectDetail : {};
    } catch (err) {
        console.log('getProjectById error: ', err);
        return {};
    }
};

export const getSelectedProjectDetailById = async (APIClient, projectId, projectInuseDetail) => {
    if(!Utils.isEmptyObject(projectInuseDetail) && projectInuseDetail?.id === projectId) {
        return projectInuseDetail;
    }
    try {
        let res = await API.graphql({
            query: getProjectDetail,
            variables: {
                params: {
                    id: projectId
                }
            }
        });
        return !Utils.isEmptyObject(res.data.getProjectDetail) ? res.data.getProjectDetail : {};
    } catch (err) {
        console.log('getProjectDetailById error: ', err);
        return {};
    }
};
export const getProjectInvite = async (APIClient, projectId) => {
    let currentProject = await getProjectById(API, projectId);
    if (currentProject && currentProject.projectInvite) {
        let projectInvite = await getProjectById(API, currentProject.projectInvite);
        return projectInvite;
    }
    return null;
};

export const getListAllProjectOfUser = async (APIClient, corporationId, userId) => {
    if (Utils.isEmpty(corporationId) || Utils.isEmpty(userId)) {
        return [];
    }
    let listAllProject = {};
    try {
        //get list user project
        let userProjectParams = prepareParamsGetListUserProject(userId);

        let resUserProjectList = await API.graphql({
            query: getProjectList,
            variables: {
                params: {
                    expression: JSON.stringify(userProjectParams)
                }
            }
        });

        if (
            Utils.isEmptyObject(resUserProjectList) ||
            Utils.isEmptyArray(resUserProjectList.data.getProjectList)
        ) {
            return [];
        }

        let userProjectList = resUserProjectList.data.getProjectList;
        userProjectList = userProjectList.filter(userProject => {
            return (
                userProject.type === Constant.PROJECT_TYPE.USER_INFO &&
                userProject.active === Constant.ACTIVE_FLAG.ACTIVE
            );
        });

        //get list project detail
        let projectParams = prepareParamsGetListAllProjectOfUser(userProjectList, corporationId);

        let resProjectList = await API.graphql({
            query: getProjectList,
            variables: {
                params: {
                    expression: JSON.stringify(projectParams)
                }
            }
        });

        listAllProject = !Utils.isEmptyArray(resProjectList.data.getProjectList)
            ? resProjectList.data.getProjectList
            : [];

        //get role PRJ_MGR of user in project
        for (let project of listAllProject) {
            let projectUser = userProjectList.find(x => x.projectId === project.id);
            project.userAddAt = projectUser.createdAt;
            if (
                !Utils.isEmptyString(projectUser.privilege) &&
                projectUser.privilege === Constant.PRIVILEGE_PROJECT.PRJ_MGR
            ) {
                project.isProjectManager = true;
            } else {
                project.isProjectManager = false;
            }
        }

        return listAllProject;
    } catch (err) {
        Logger.error('getAllListProjectOfUser err :>> ', err);
        return listAllProject;
    }
};

// get list project of corporation
export const getListProjectInCorporationForDelegate = async (APIClient, corporationId) => {
    try {
        const dynamodbExpression = prepareParamsQueryListProjectInCorporationForDelegate(
            corporationId
        );
        let queryParams = {
            query: getProjectList,
            variables: {
                params: {
                    expression: JSON.stringify(dynamodbExpression)
                }
            }
        };
        // call api
        let resData = await API.graphql(queryParams);
        // handler response
        let projectData = resData.data.getProjectList;
        let guestProjectList =
            !Utils.isEmptyObject(projectData) && !Utils.isEmptyArray(projectData)
                ? projectData
                : null;
        return guestProjectList;
    } catch (err) {
        console.log('getCustomerProjectByCorporation error:', err);
        return null;
    }
};

export const getListProjectInCorporationForB2BCustomer = async (APIClient, corporationId) => {
    if (!corporationId) {
        return [];
    }

    try {
        const dynamodbExpression = DynamoDBProjectRequestDto.prepareParamsQueryProjectGSI1(
            corporationId,
            Constant.PROJECT_TYPE.PRJ_BUSINESS_CUSTOMER,
            Constant.ACTIVE_FLAG.ACTIVE
        );
        let queryParams = {
            query: getProjectList,
            variables: {
                params: {
                    expression: JSON.stringify(dynamodbExpression)
                }
            }
        };
        // call api
        let resData = await API.graphql(queryParams);
        // handler response
        return resData.data?.getProjectList;
    } catch (err) {
        console.log('get project list error:', err);
        return null;
    }
};

/**
 * Get userProject in user detail
 * @param {*} APIClient
 * @param {*} userId
 * @param {*} projectId
 * @returns userInProject
 */
export const getProjectUserInUseDetail = async (APIClient, userId, projectId) => {
    if (!userId || !projectId) {
        return null;
    }

    try {
        let params = {
            query: getProjectList,
            variables: {
                params: {
                    expression: JSON.stringify(prepareParamsGetUserInfoInProject(userId, projectId))
                }
            }
        };

        const resGetProjectUserDetail = await API.graphql(params);
        return resGetProjectUserDetail.data.getProjectList.length > 0
            ? resGetProjectUserDetail.data.getProjectList[0]
            : null;
    } catch (err) {
        console.log('getProjectUserInUseDetail error: ', err);
        return null;
    }
};

/**
 * get Current Project Manager List In Project
 * @param {*} APIClient
 * @param {*} corporationId
 * @returns get PM in prj
 */

export const getProjectManagerListInProject = async (APIClient, projectId) => {
    if (!projectId) {
        return [];
    }

    try {
        let params = {
            query: getProjectList,
            variables: {
                params: {
                    expression: JSON.stringify(
                        prepareParamsGetAllProjectManagerOfProject(projectId)
                    )
                }
            }
        };
        const resGetProjectManagerList = await API.graphql(params);

        let projectManagerList = resGetProjectManagerList?.data?.getProjectList || [];
        if (Utils.isEmptyArray(projectManagerList)) {
            return [];
        }
        return projectManagerList;
    } catch (err) {
        console.log('getProjectManagerListInProject :>> ', err);
        return null;
    }
};

export const getListProjectByListId = async (APIClient, listId) => {
    try {
        if (Utils.isEmptyArray(listId)) {
            return [];
        }

        let projectList = await getProjectListByIdList(listId);
        return projectList;
    } catch (err) {
        console.log('getListProjectByListId :>> ', err);
        return null;
    }
};

export const getListGuestProject = async (APIClient, projectDetail) => {
    try {
        let listId = [];
        let projectInviterExternalDesk = [];
        const listInviteExternalDeskTicket = await getActiveB2BCustomerProjectListOfProject(
            API,
            projectDetail.id
        );
        if (!Utils.isEmptyArray(listInviteExternalDeskTicket)) {
            listInviteExternalDeskTicket.forEach(projectId => {
                listId.push(projectId);
                projectInviterExternalDesk.push(projectId);
            });
        }

        if (!Utils.isEmptyArray(listId)) {
            const listProject = await getListProjectByListId(API, listId);
            let listGuestProject = [];
            let listProjectDetail = [];
            let inviteCorporationList = [];
            let corporationList = [];
            for (const project of listProject) {
                if (
                    project.active === Constant.ACTIVE_FLAG.ACTIVE &&
                    (Utils.isProjectGuest(project) ||
                        (projectInviterExternalDesk.includes(project.id) &&
                            project.type === Constant.PROJECT_TYPE.GENERAL))
                ) {
                    if (!inviteCorporationList.includes(project.affiliationOrganization)) {
                        inviteCorporationList.push(project.affiliationOrganization);
                    }
                    listGuestProject.push(project);
                }
            }

            let listCorporationId = [];
            if (!Utils.isEmptyArray(inviteCorporationList)) {
                inviteCorporationList.forEach(id => {
                    listCorporationId.push(id);
                });
                let listCorporationDetail = await getCorporationListByIdList(listCorporationId);
                corporationList = listCorporationDetail;
                for (const project of listGuestProject) {
                    let projectTemp = { ...project };
                    const corporationDetail = listCorporationDetail.find(
                        corporation => corporation.id === project.affiliationOrganization
                    );
                    if (
                        !Utils.isEmptyObject(corporationDetail) &&
                        corporationDetail.active === Constant.ACTIVE_FLAG.ACTIVE
                    ) {
                        projectTemp.label = `${Utils.getTextByLanguage(
                            Constant.LANGUAGE_TYPE.JP,
                            corporationDetail.name
                        )} (${Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, project.name)})`;
                        projectTemp.corporationData = corporationDetail;
                        listProjectDetail.push(projectTemp);
                    }
                }
            }
            return { listProjectDetail, corporationList };
        } else {
            return { listProjectDetail: [], corporationList: [] };
        }
    } catch (err) {
        console.log('getListGuestProject :>> ', err);
    }
};

/**
 * getProjectInCorporationByProjectType
 * @param {*} APIClient
 * @param {*} corporationId
 * @param {*} projectType
 * @returns
 */
export const getProjectInCorporationByProjectType = async (APIClient, corporationId, projectType) => {
    try {
        let param = {
            affiliationOrganization: corporationId,
            filter: {
                type: { eq: projectType }
            }
        };
        let resProjectList = await API.graphql({
            query: queryProjectGSI1,
            variables: param
        });

        if (
            Utils.isEmptyObject(resProjectList) ||
            Utils.isEmptyArray(resProjectList.data.queryProjectGSI1.items)
        ) {
            return [];
        }

        return resProjectList.data.queryProjectGSI1.items;
    } catch (err) {
        console.log('getProjectInCorporationByProjectType error: ', err);
        return [];
    }
};

/**
 * getHelpDeskListData
 * @param {*} APIClient
 * @param {*} projectDetail
 * @returns
 */
export const getHelpDeskListData = async (APIClient, projectDetail) => {
    try {
        let projectList = [];
        let corporationList = [];

        if (Utils.isEmptyObject(projectDetail)) {
            return { projectList, corporationList };
        }

        let listProjectDesk = await getActiveB2BHelpdeskProjectListOfProject(API, projectDetail.id);
        if (Utils.isEmptyArray(listProjectDesk)) {
            return { projectList, corporationList };
        }

        await Promise.all(
            listProjectDesk.map(async projectId => {
                let projectData = await getProjectById(API, projectId);

                // Helpdesk prj only
                if (
                    !Utils.isEmptyObject(projectData) &&
                    !Utils.isProjectGuest(projectData) &&
                    projectData.affiliationOrganization
                ) {
                    let corporationData = await getCorporationById(
                        API,
                        projectData.affiliationOrganization
                    );
                    projectList.push(projectData);
                    if (Utils.findIndexInArrayById(corporationData.id, corporationList) === -1) {
                        corporationList.push(corporationData);
                    }
                }
            })
        );

        return { projectList, corporationList };
    } catch (err) {
        console.log('getHelpDeskListData :>> ', err);
        return { projectList: [], corporationList: [] };
    }
};

/**
 * filterExternalCustomerProject
 * @param {*} APIClient
 * @param {*} projectId
 * @param {*} corporationId
 * @param {*} keyword
 * @returns
 */
export const filterExternalCustomerProject = async (APIClient, projectId, corporationId, keyword) => {
    try {
        let searchCondition = {
            params: {
                projectId,
                corporationId,
                keyword
            }
        };

        const res = await API.graphql({
            query: getExternalCustomerProjectList,
            variables: searchCondition
            // authMode: Constant.AUTH_MODE_API_KEY,
        });

        let projectList = !Utils.isEmptyArray(res?.data?.getExternalCustomerProjectList)
            ? res?.data?.getExternalCustomerProjectList
            : [];
        return projectList;
    } catch (err) {
        console.log('filterExternalCustomerProject :>> ', err);
        return [];
    }
};

/**
 *
 * @param {*} APIClient
 * @param {*} project
 * @returns
 */
export const formatResponseB2BCustomerProject = async (APIClient, project) => {
    const orgId = project.affiliationOrganization;
    let orgInfo = await getCorporationById(API, orgId);
    const isNotExistedLogo =  Utils.isEmpty(orgInfo.image) || Utils.isEmptyString(orgInfo.image) ||  Utils.isEmpty(orgInfo.logoFileName) || Utils.isEmptyString(orgInfo.logoFileName) 
    const logoS3Path = `${orgInfo.image}/${orgInfo.logoFileName}`

    return {
        id: project.projectId,
        logo: isNotExistedLogo ? Constant.LOGO_DEFAULT : await Storage.get(logoS3Path),
        orgId: orgInfo.id,
        orgActive: orgInfo.active,
        orgName: Utils.getCorporationName(Constant.LANGUAGE_TYPE.JP, orgInfo),
        organizationDomain: orgInfo.organizationDomain,
        projectName: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, project.name),
        contractType: orgInfo.contractType,
        status: project.status,
        active: project?.active,
        name: project?.name,
        type: project?.type,
        isTicket: project.isTicket,
        updatedAt: project.updatedAt
    };
};

/**
 *
 * @param {*} APIClient
 * @param {*} project
 * @returns
 */
export const formatResponseB2BHelpDeskProject = async (APIClient, project) => {
    const orgId = project.affiliationOrganization;
    let orgInfo = await getCorporationById(API, orgId);

    return {
        orgId: orgInfo.id,
        orgName: Utils.getCorporationName(Constant.LANGUAGE_TYPE.JP, orgInfo),
        organizationDomain: orgInfo.organizationDomain,
        orgActive: orgInfo.active
    };
};

/**
 *
 * @param {*} APIClient
 * @param {*} projectId
 * @returns
 */

export const getActiveB2BCustomerListInProjectByProjectId = async (APIClient, projectId) => {
    if (!projectId) {
        return [];
    }

    let b2bCustomerList = [];
    try {
        let getAllB2BCustomerInProjectParams = DynamoDBProjectRequestDto.prepareParamsQueryProjectGSI3(
            projectId,
            Constant.PROJECT_TYPE.PRJ_BUSINESS_CUSTOMER
        );

        let getAllInfoProjectContainB2B = await API.graphql({
            query: getProjectList,
            variables: {
                params: {
                    expression: JSON.stringify(getAllB2BCustomerInProjectParams)
                }
            }
        });
        getAllInfoProjectContainB2B = getAllInfoProjectContainB2B.data.getProjectList;
        b2bCustomerList = await Promise.all(
            getAllInfoProjectContainB2B.map(async project => {
                if (project.id2) {
                    let currentProject = await getProjectById(API, project.id2);
                    currentProject.isTicket = false;
                    currentProject.status =
                        project.active === Constant.ACTIVE_FLAG.ACTIVE
                            ? Constant.B2B_CUSTOMER_PROJECT_STATUS.ACTIVE
                            : Constant.B2B_CUSTOMER_PROJECT_STATUS.DELETED;
                    currentProject = await formatResponseB2BCustomerProject(API, currentProject);
                    return currentProject;
                }
            })
        );

        return b2bCustomerList;
    } catch (err) {
        Logger.error('getActiveB2BCustomerListInProjectByProjectId', err);
        return b2bCustomerList;
    }
};

export const getActiveB2CCustomerListInProjectByProjectId = async (APIClient, projectId) => {
    if (!projectId) {
        return [];
    }

    let b2cCustomerList = [];
    try {
        let getAllB2CCustomerInProjectParams = DynamoDBProjectRequestDto.prepareParamsQueryProjectGSI3(
            projectId,
            Constant.PROJECT_TYPE.USER_CUSTOMER,
            Constant.ACTIVE_FLAG.ACTIVE
        );

        let getAllInfoProjectContainB2C = await API.graphql({
            query: getProjectList,
            variables: {
                params: {
                    expression: JSON.stringify(getAllB2CCustomerInProjectParams)
                }
            }
        });

        getAllInfoProjectContainB2C = getAllInfoProjectContainB2C.data.getProjectList;

        let userIdList = [];
        getAllInfoProjectContainB2C.forEach(userProject => {
            if (userProject.id2) {
                userIdList.push(userProject.id2);
            }
        });

        b2cCustomerList = getUserListByIdList(API, userIdList);
        return b2cCustomerList;
    } catch (err) {
        Logger.error('getActiveB2BCustomerListInProjectByProjectId', err);
        return b2cCustomerList;
    }
};

/**
 * getActiveB2BHelpdeskProjectListOfProject
 * @param {*} API
 * @param {*} projectId
 * @returns
 */
export const getActiveB2BHelpdeskProjectListOfProject = async (
    APIClient,
    projectId,
    isGetDetail = false
) => {
    if (!projectId) {
        return [];
    }

    try {
        let getB2BHelpdeskProjectListParams = DynamoDBProjectRequestDto.prepareParamsGetB2BHelpdeskProjectList(
            projectId,
            Constant.ACTIVE_FLAG.ACTIVE
        );
        let resGetB2BHelpdeskProjectListParams = await API.graphql({
            query: getProjectList,
            variables: {
                params: {
                    expression: JSON.stringify(getB2BHelpdeskProjectListParams)
                }
            }
        });

        if (Utils.isEmptyArray(resGetB2BHelpdeskProjectListParams?.data?.getProjectList)) {
            return [];
        }

        let helpdeskList = [];
        let helpdeskListResult = resGetB2BHelpdeskProjectListParams?.data?.getProjectList;
        helpdeskListResult.forEach(project => {
            if (!helpdeskList.includes(project.projectId)) {
                helpdeskList.push(project.projectId);
            }
        });

        if (isGetDetail) {
            return await getListProjectByListId(API, helpdeskList);
        }

        return helpdeskList;
    } catch (err) {
        Logger.error('getActiveB2BHelpdeskProjectListOfProject error: ', err);
        return [];
    }
};

export const currentProjectIsCustomerOfProjectTarget = (listB2BHelpdesk, projectTargetId) => {
    if (Utils.isEmptyArray(listB2BHelpdesk)) {
        return false;
    }

    let projectHelpdesk = listB2BHelpdesk.find(
        project => project.id === projectTargetId && project.active === Constant.ACTIVE_FLAG.ACTIVE
    );
    if (projectHelpdesk && !Utils.isEmptyObject(projectHelpdesk)) {
        return true;
    }

    return false;
};

export const currentProjectIsHelpdeskOfProjectTarget = (listB2BCustomer, projectTargetId) => {
    if (Utils.isEmptyArray(listB2BCustomer)) {
        return false;
    }

    let projectCustomer = listB2BCustomer.find(
        project => project.id === projectTargetId && project.active === Constant.ACTIVE_FLAG.ACTIVE
    );
    if (projectCustomer && !Utils.isEmptyObject(projectCustomer)) {
        return true;
    }

    return false;
};

/**
 * getActiveB2BHelpdeskProject
 * @param {*} APIClient
 * @param {*} projectId
 * @returns
 */
export const getActiveB2BHelpdeskProject = async (APIClient, projectId) => {
    if (!projectId) {
        return [];
    }

    try {
        let getB2BHelpdeskProjectListParams = DynamoDBProjectRequestDto.prepareParamsGetB2BHelpdeskProjectList(
            projectId,
            Constant.ACTIVE_FLAG.ACTIVE
        );
        let resGetB2BHelpdeskProjectListParams = await API.graphql({
            query: getProjectList,
            variables: {
                params: {
                    expression: JSON.stringify(getB2BHelpdeskProjectListParams)
                }
            }
        });

        if (Utils.isEmptyArray(resGetB2BHelpdeskProjectListParams?.data?.getProjectList)) {
            return [];
        }

        const getAllInfoProjectContainB2B =
            resGetB2BHelpdeskProjectListParams?.data?.getProjectList;
        const b2bHelpDeskList = await Promise.all(
            getAllInfoProjectContainB2B.map(async project => {
                const result = await formatResponseB2BHelpDeskProject(API, project);
                return result;
            })
        );
        return b2bHelpDeskList;
    } catch (err) {
        Logger.error('getActiveB2BHelpdeskProjectListOfProject error: ', err);
        return [];
    }
};

/**
 * getActiveB2BCustomerProjectListOfProject
 * @param {*} API
 * @param {*} projectId
 * @returns
 */
export const getActiveB2BCustomerProjectListOfProject = async (
    APIClient,
    projectId,
    isGetDetail = false,
    active = Constant.ACTIVE_FLAG.ACTIVE
) => {
    if (!projectId) {
        return [];
    }

    try {
        const getB2BCustomerProjectListParams = DynamoDBProjectRequestDto.prepareParamsGetB2BCustomerProjectList(
            projectId,
            active
        );
        let resGetB2BCustomerProjectListParams = await API.graphql({
            query: getProjectList,
            variables: {
                params: {
                    expression: JSON.stringify(getB2BCustomerProjectListParams)
                }
            }
        });

        if (Utils.isEmptyArray(resGetB2BCustomerProjectListParams.data?.getProjectList)) {
            return [];
        }

        let getB2BCustomerProjectListRes = [];
        resGetB2BCustomerProjectListParams.data?.getProjectList.forEach(project => {
            if (!getB2BCustomerProjectListRes.includes(project.id2)) {
                getB2BCustomerProjectListRes.push(project.id2);
            }
        });

        if (isGetDetail) {
            return await getListProjectByListId(API, getB2BCustomerProjectListRes);
        }

        return getB2BCustomerProjectListRes;
    } catch (err) {
        console.log('getActiveB2BCustomerProjectListOfProject error: ', err);
        return [];
    }
};

/**
 * getProjectListUserIsB2C
 * @param {*} APIClient
 * @param {*} corporationId
 * @param {*} userId
 * @returns
 */
export const getProjectListUserIsB2C = async (APIClient, userId) => {
    const expression = DynamoDBProjectRequestDto.prepareParamsQueryProjectGSI2(
        userId,
        Constant.PROJECT_TYPE.USER_CUSTOMER
    );
    if (!expression || Utils.isEmptyObject(expression)) {
        return [];
    }

    let projectList = [];
    let relationRecord = [];

    let resUserProjectList = await API.graphql({
        query: getProjectList,
        variables: {
            params: {
                expression: JSON.stringify(expression)
            }
        }
    });
    if (
        Utils.isEmptyObject(resUserProjectList) ||
        Utils.isEmptyArray(resUserProjectList.data.getProjectList)
    ) {
        return { projectList, relationRecord };
    }

    relationRecord = resUserProjectList.data.getProjectList;
    relationRecord.forEach(project => {
        if (!projectList.includes(project.projectId)) {
            projectList.push(project.projectId);
        }
    });

    return { projectList, relationRecord };
};

export const getCorporationNameForProjectList = async (APIClient, projectList) => {
    if (Utils.isEmptyArray(projectList)) return [];

    let listCorpId = projectList.map(p => p.affiliationOrganization);
    if (Utils.isEmptyArray(listCorpId)) return [];

    let listCorporationDetail = await getCorporationListByIdList(listCorpId);

    projectList = cloneDeep(projectList);
    projectList.forEach(project => {
        let affiliationOrganization = project.affiliationOrganization;
        let corporationDetail = listCorporationDetail.find(
            corporation => corporation.id === affiliationOrganization
        );

        if (!Utils.isEmptyObject(corporationDetail)) {
            let corpName = Utils.getCorporationName(Constant.LANGUAGE_TYPE.JP, corporationDetail);
            let projectNameString = Utils.getTextByLanguage(
                Constant.LANGUAGE_TYPE.JP,
                project.name
            );

            let projectName = {
                jp: { A: 'F', text: `${projectNameString} (${corpName})` }
            };
            project.name = projectName;
            project.corpActive = corporationDetail.active;
        }
    });

    return projectList;
};

/**
 * handleUpdateProjectResource
 * @param {*} APIClient
 * @param {*} params
 * @returns
 */
export const handleUpdateProjectResource = async (APIClient, params) => {
    try {
        const result = await API.graphql({
            query: updateProjectResource,
            variables: {
                updateProjectResourceRequestDto: params
            }
        });

        return result.data.updateProjectResource;
    } catch (err) {
        console.log('handleUpdateProjectResource err', err);
        return null;
    }
};

export const getListCategoryAndChatbotSettingWithoutAuthen = async (APIClient, params) => {
    try {
        let getProjectResult = await getPublicAPI(API, params);
        if (getProjectResult.success) {
            let response = Utils.convertJSONDataToObject(getProjectResult.payload);
            response.success = true;
            return response;
        }

        return getProjectResult;
    } catch (err) {
        console.log('getFormByIdWithoutAuthen error: ', err);
        return {};
    }
};

/**
 * getProjectAliasAndSubDomainByProjectId
 * @param {*} APIClient
 * @param {*} projectId
 * @returns
 */
export const getProjectAliasAndSubDomainByProjectId = async (APIClient, projectId) => {
    try {
        let response;

        let params = {
            getApiType: Constant.GET_API_PUBLIC_TYPE.GET_PROJECT_ALIAS_AND_SUB_DOMAIN_BY_PROJECT_ID,
            projectId: projectId
        };

        let getProjectInitData = await getPublicAPI(API, params);
        if (getProjectInitData.success) {
            response = Utils.convertJSONDataToObject(getProjectInitData.payload);
        }

        return response;
    } catch (err) {
        console.log('getProjectAliasAndSubDomainByProjectId error: ', err);
        return {};
    }
};

export const getListProjectInviteSupported = async (APIClient, projectId) => {
    const expression = DynamoDBProjectRequestDto.prepareParamsQueryProjectGSI2(
        projectId,
        Constant.PROJECT_TYPE.PRJ_BUSINESS_CUSTOMER,
        Constant.ACTIVE_FLAG.ACTIVE
    );
    if (!expression || Utils.isEmptyObject(expression)) {
        return [];
    }

    let projectList = [];
    let relationRecord = [];

    let resUserProjectList = await API.graphql({
        query: getProjectList,
        variables: {
            params: {
                expression: JSON.stringify(expression)
            }
        }
    });
    if (
        Utils.isEmptyObject(resUserProjectList) ||
        Utils.isEmptyArray(resUserProjectList.data.getProjectList)
    ) {
        return projectList;
    }

    relationRecord = resUserProjectList.data.getProjectList;
    relationRecord.forEach(project => {
        if (!projectList.includes(project.projectId)) {
            projectList.push(project.projectId);
        }
    });

    return projectList;
};

export const updateAISettingForProjectSetting = async (APIClient, params) => {
    try {
        let queryParams = {
            query: updateAISettingsForKnowledgePrompt,
            variables: {
                updateAISettingsForKnowledgePromptRequestDto: params
            }
        };
    
        let result = await API.graphql(queryParams);
    
        return result.data?.updateAISettingsForKnowledgePrompt;
    } catch (error) {
        console.error('updateAISettingForProjectSetting >>', error);
    }
}


/**
 * getProjectIdListUserIsB2C
 * @param {*} APIClient 
 * @param {*} userId 
 * @returns 
 */
export const getProjectIdListUserIsB2C = async (APIClient, userId) => {
    if (!userId) return [];

    let projectIdList = [];

    try {
        //get list user project
        let userProjectParams = DynamoDBProjectRequestDto.prepareParamsGetProjectIdListUserIsB2C(
            userId
        );

        let resUserProjectList = await API.graphql({
            query: getProjectList,
            variables: {
                params: {
                    expression: JSON.stringify(userProjectParams)
                }
            }
        });

        if (
            Utils.isEmptyObject(resUserProjectList) ||
            Utils.isEmptyArray(resUserProjectList.data.getProjectList)
        ) {
            return [];
        }

        let userProjectList = resUserProjectList.data.getProjectList;

        if (!Utils.isEmptyArray(userProjectList)) {
            userProjectList.forEach(userProjectData => {
                if (userProjectData.active === Constant.ACTIVE_FLAG.ACTIVE) {
                    projectIdList.push(userProjectData.projectId);
                }
            });
        }

        return projectIdList;
    } catch (err) {
        Logger.error('getProjectIdListUserIsB2C err :>> ', err);
        return [];
    }
};


/**
 * getActiveProjectDetailListIsB2CByUserId
 * return detail of project list user is b2c
 * @param {*} APIClient 
 * @param {*} userId 
 * @param {*} activeProject 
 */
export const getActiveProjectDetailListIsB2CByUserId = async (APIClient, userId) => {
    if (!userId) return [];

    let projectIdListUserIsB2C = await getProjectIdListUserIsB2C(API, userId);
    if (Utils.isEmptyArray(projectIdListUserIsB2C)) return [];

    let projectDetailList = [];

    await Promise.all(
        projectIdListUserIsB2C.map(async projectId => {
            let projectDetail = await getProjectById(API, projectId);
            if (Utils.isEmptyObject(projectDetail) || (projectDetail.active !== Constant.ACTIVE_FLAG.ACTIVE)) return;

            projectDetailList.push({
                id: projectDetail.id,
                name: projectDetail.name,
                type: projectDetail.type,
                corpDetail: {
                    id: projectDetail.affiliationOrganization,
                    name: ''
                },
                projectSetting: projectDetail.projectSetting ? projectDetail.projectSetting : '',
                affiliationOrganization: projectDetail.affiliationOrganization
            })
        })
    )

    return projectDetailList;
}

export const isCurrentProjectIsCustomerOfProjectTarget = async (APIClient, currentProjectId, projectTargetId) => {
    let projectTargetB2BCustomerList = await getProjectBusinessCustomerReCord(API, projectTargetId);
    if (Utils.isEmptyArray(projectTargetB2BCustomerList)) {
        return false;
    }

    let currentProjectInfo = projectTargetB2BCustomerList.find(project => project.id2 === currentProjectId && project.active === Constant.ACTIVE_FLAG.ACTIVE);
    if (currentProjectInfo && !Utils.isEmptyObject(currentProjectInfo)) {
        return true;
    }
    return false;
}

export const getProjectBusinessCustomerReCord = async (APIClient, projectId, active) => {
    try {
        const dynamodbParams = DynamoDBProjectRequestDto.prepareParamsGetProjectBusinessCustomerReCord(
            projectId,
            active
        );

        let resData = await API.graphql({
            query: getProjectList,
            variables: {
                params: {
                    expression: JSON.stringify(dynamodbParams)
                }
            }
        });
        
        if (
            Utils.isEmptyObject(resData) ||
            Utils.isEmptyArray(resData.data.getProjectList)
        ) {
            return [];
        }

        return resData.data.getProjectList;
    } catch (err) {
        return [];
    }
}


/**
 * getProjectIdListUserIsMember
 * get all project id list user is member
 * @param {*} corporationId 
 * @param {*} userId 
 * @returns 
 */
export const getProjectIdListUserIsMember = async (corporationId, userId) => {
    try {
        const expression = prepareParamsGetListProjectByUserId(corporationId, userId);
        if (!expression || Utils.isEmptyObject(expression)) {
            return [];
        }

        let resUserProjectList = await API.graphql({
            query: getProjectList,
            variables: {
                params: {
                    expression: JSON.stringify(expression)
                }
            }
        });
        if (
            Utils.isEmptyObject(resUserProjectList) ||
            Utils.isEmptyArray(resUserProjectList.data.getProjectList)
        ) {
            return [];
        }

        // get detail project
        let userProjectList = resUserProjectList.data.getProjectList;
        let lisProjectId = [];
        userProjectList.forEach(user => {
            lisProjectId.push(user.projectId);
        });

        return lisProjectId;
    } catch (err) {
        console.log('getProjectListInCorporationByUserId error: ', err);
        return [];
    }
};

export const getB2BCustomerListInProjectByProjectId = async (APIClient, projectId) => {
    if (!projectId) {
        return [];
    }

    let b2bCustomerList = [];
    try {
        let getAllB2BCustomerInProjectParams = DynamoDBProjectRequestDto.prepareParamsQueryProjectGSI3(
            projectId,
            Constant.PROJECT_TYPE.PRJ_BUSINESS_CUSTOMER
        );

        let getAllInfoProjectContainB2B = await API.graphql({
            query: getProjectList,
            variables: {
                params: {
                    expression: JSON.stringify(getAllB2BCustomerInProjectParams)
                }
            }
        });
        getAllInfoProjectContainB2B = getAllInfoProjectContainB2B.data.getProjectList;
        b2bCustomerList = await Promise.all(
            getAllInfoProjectContainB2B.map(async project => {
                if (project.id2) {
                    let currentProject = await getProjectById(API, project.id2);
                    currentProject.isTicket = false;
                    currentProject.status =
                        project.active === Constant.ACTIVE_FLAG.ACTIVE
                            ? Constant.B2B_CUSTOMER_PROJECT_STATUS.ACTIVE
                            : Constant.B2B_CUSTOMER_PROJECT_STATUS.DELETED;
                    currentProject = await formatResponseB2BCustomerProject(API, currentProject);
                    return currentProject;
                }
            })
        );

        return b2bCustomerList;
    } catch (err) {
        Logger.error('getActiveB2BCustomerListInProjectByProjectId', err);
        return b2bCustomerList;
    }
};

export const getProjectByIds = async (ids = []) => {
    try {
        const response = await getPublicAPI(null, {
            getApiType: Constant.GET_API_PUBLIC_TYPE.GET_PROJECT_BY_IDS,
            ids: ids
        });
        return Utils.convertJSONDataToObject(response?.payload);
    } catch (err) {
        console.log('getProjectByIdList err: ', err);
        return [];
    }
};